/* eslint-disable max-params */

import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import { connect } from "dva";
import ChatState from "@/types/chat/State";

import CHAT_NOTICE, {
  ALL_NOTICE_TAB_LIST,
  UNABLE_EDIT_TABS_PIN,
  UNABLE_SHOW_TABS_PIN
} from "@/contant/chat";
import { Modal, Spin, Dropdown, Empty } from "antd";
import noticeImg from "@/assets/img/empty/im-empty.png";
import { RecommendedType } from "@/services/AppStore";
import ToolsItem from "../ToolsItem/index";
import DragableToolsItem from "../DragableToolsItem/index";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Employee, Session, SessionType } from "@/types/chat";
import { batchSetCustomAppConfig } from "@/api/chat";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";

import "./index.less";
import { analysisLog } from "@/utils/logAnalytics";
import classNames from "classnames";
import ImService from "@/server/ImService";
import IconFont from "@/components/icon";
import AsyncTaskQueue from "@/utils/asyncTaskQueue";
import { SessionSettingsType } from "@/types/chat/enum";
import { sessionSetting } from "@/server/im/SessionService";
import { filterNoticeSession, usePrevious } from "@/utils/chat/index";
import { sleep } from "@/utils/chat/message";
import { getAIConfigData } from "@/utils/tools";

// 设置样式
/* eslint max-params: ["error", 4] */
const getItemStyle = (isDragging: any, draggableStyle: any, isPointer: any) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  position: "relative",
  cursor: isPointer ? "move" : "default",
  // styles we need to apply on draggables
  ...draggableStyle
});

interface IProps {
  visible: boolean;
  handleOk: Function;
  handleCancel: Function;
  selectedTabList: any[];
  isPointer: boolean;
  selectedSession: Session;
  aiNoticeSessionList: Session[];
  allSessionList: Session[];
  currentEmployee: Employee;
  customAppList: Session[];
  updateCustomAppList: Function;
  updateAISessionDataList: Function;
}

// eslint-disable-next-line complexity
function TabControllerModal(props: IProps) {
  const {
    visible,
    selectedTabList,
    aiNoticeSessionList,
    isPointer,
    handleCancel,
    handleOk,
    currentEmployee,
    customAppList,
    updateCustomAppList,
    allSessionList,
    updateAISessionDataList
  } = props;
  const { appRuntimeEnv } = React.useContext<GlobalContextConfig>(GlobalContext);
  const [isDragging, setDragging] = useState(false);
  const [moreTabList, setMoreTabList] = useState<any[]>([]);
  const [mineTabList, setMineTabList] = useState<any[]>([]);
  const [activedKey, setActivedKey] = useState("ai");
  const [loading, setLoading] = useState(false);
  const [appList, setAppList] = useState<Session[]>(
    JSON.parse(JSON.stringify(customAppList.filter((i) => i.settings?.isShow !== false)))
  );
  const updateSettingsListRef = useRef<Session[]>([]);
  const needUpdateCustomAppListRef = useRef(false);
  // 操作过的移入消息盒子
  const updateDeleteRef = useRef<Session[]>([]);
  const taskQueueRef = useRef(new AsyncTaskQueue());
  const preVisible = usePrevious(visible);

  const aiConfigName = useMemo(() => {
    const aiUser = getAIConfigData(appRuntimeEnv, "envConfig.aiConfig.aiUser");
    return aiUser?.name;
  }, [appRuntimeEnv]);

  const onDragEnd = (result: any) => {
    // eslint-disable-next-line no-console
    setDragging(false);
    if (!result.destination) {
      return;
    }
    const { index: startIndex, droppableId: originalId } = result.source;
    const { index: endIndex, droppableId: targetId } = result.destination;
    // 当没有改变排序时，不触发此方法。
    if (startIndex === endIndex && originalId === targetId) {
      return;
    }
    const targetTabListData: any = {
      mine: mineTabList,
      more: moreTabList
    };
    updateTabList(targetTabListData, originalId, targetId, startIndex, endIndex);
  };

  /**
   * tab移动加减符号点击操作
   * @param originalId 当前点击的tab的droppableId
   * @param pin 当前tab的pin
   */
  const handleToolsItemClick = (originalId: string, sessionId: string) => {
    const targetTabListData: any = {
      mine: mineTabList,
      more: moreTabList
    };
    let targetId = originalId === "mine" ? "more" : "mine";
    const index = targetTabListData[originalId].findIndex(
      (item: Session) => item.sessionId === sessionId
    );
    updateTabList(
      targetTabListData,
      originalId,
      targetId,
      index,
      targetTabListData[targetId].length
    );
  };

  /**
   * 更新我的组合和更多组合
   * @param targetTabListData 我的分组和更多分组的tabList的对象集合
   * @param originalId 当前操作区域的droppableId
   * @param targetId 目标区域的droppableId
   * @param startIndex 起始位置
   * @param endIndex 移动到的位置
   */
  const updateTabList = (
    targetTabListData: any,
    originalId: string,
    targetId: string,
    startIndex: number,
    endIndex: number
  ) => {
    // 删除原数组中元素
    const [removed] = targetTabListData[originalId].splice(startIndex, 1);
    // 将原来的元素添加进数组
    targetTabListData[targetId].splice(endIndex, 0, removed);
    setMineTabList([...targetTabListData["mine"]]);
    setMoreTabList([...targetTabListData["more"]]);
  };

  const aiList = useMemo(() => {
    return JSON.parse(JSON.stringify(aiNoticeSessionList)) as Session[];
  }, [aiNoticeSessionList]);

  const formatTabList = useCallback(async () => {
    const imService = ImService.getInstance();
    const moreTabList: any[] =
    aiList.filter((item: Session) => {
        return !selectedTabList.find(
          (selectedTabItem) => (item.info as Employee).userId === selectedTabItem.pin
        );
      }) || [];
    const mineTabList: any[] = await Promise.all(
      selectedTabList
        .filter((item) => !UNABLE_SHOW_TABS_PIN.includes(item.pin))
        .map(async (item) => {
          const target = aiList.find((session) => (session.info as Employee).userId === item.pin);
          if (target) {
            return target;
          } else {
            const sessionId = imService.generateSingleSessionId(
              {
                app: item.app || currentEmployee.app,
                userId: item.pin,
                teamId: item.teamId || currentEmployee.teamId
              } as any,
              {
                pin: currentEmployee.userId,
                app: currentEmployee.app,
                teamId: currentEmployee.teamId
              }
            );
            const session = await imService.getSessionBySessionId({
              sessionId,
              sessionType: SessionType.NOTICE
            });
            return session;
          }
        })
    );
    setMoreTabList([...moreTabList]);
    setMineTabList([...filterNoticeSession(mineTabList, customAppList)]);
  }, [
    aiList,
    currentEmployee.app,
    currentEmployee.teamId,
    currentEmployee.userId,
    selectedTabList,
    customAppList
  ]);

  useEffect(() => {
    // 限制打开浮层处理一次
    if (visible && !preVisible) {
      formatTabList();
    }
  }, [formatTabList, preVisible, visible]);

  const handleConfirm = () => {
    if (updateSettingsListRef.current.length) {
      const promiseList: (() => Promise<any>)[] = [];
      updateSettingsListRef.current.forEach((item) => {
        const newVal = item.settings.shield ? true : false;
        const sessionId = item.sessionId;
        promiseList.push(() => sessionSetting(SessionSettingsType.SHIELD, sessionId, newVal));
        updateAISessionDataList({
          session: {
            sessionId: item.sessionId,
            settings: {
              shield: newVal ? 1 : 0
            }
          }
        });
      });
      taskQueueRef.current.addTasks(promiseList);
      updateCustomAppList({
        customAppList: appList
      });
    }
    const tabList = mineTabList.map((item) => ({
      pin: (item.info as Employee).userId,
      app: (item.info as Employee).app,
      teamId: (item.info as Employee).teamId,
      name: (item.info as Employee).name
    }));
    if (needUpdateCustomAppListRef.current) {
      needUpdateCustomAppListRef.current = false;
      const _appList = appList.map((item) => ({
        appKey: (item.info as Employee).userId,
        appName: (item.info as Employee).name
      }));
      const delList = updateDeleteRef.current.map((item) => ({
        appKey: (item.info as Employee).userId,
        appName: (item.info as Employee).name
      }));
      batchSetCustomAppConfig({ appList: _appList, delList }).then((res) => {
        handleOk(tabList);
      });
    } else {
      handleOk(tabList);
    }
  };

  const updateAppList = (list: Session[], setList: Function, item: Session) => {
    const index = list.findIndex(
      (app) => (app.info as Employee).userId === (item.info as Employee).userId
    );
    if (index !== -1) {
      const [target] = list.splice(index, 1);
      setList([...list]);
      return target;
    }
    return null;
  };

  const handleAppToggle = (type: string, item: any, isMine: boolean) => {
    needUpdateCustomAppListRef.current = true;
    if (type === "delete") {
      const target = updateAppList(appList, setAppList, item);
      if (target) {
        const idx = updateDeleteRef.current.findIndex((i) => i.sessionId === target.sessionId);
        if (idx > -1) {
          updateDeleteRef.current.splice(idx, 1, target);
        } else {
          updateDeleteRef.current.push(target);
        }
        setMoreTabList([...moreTabList, target]);
      }
    } else {
      const sourceList = isMine ? mineTabList : moreTabList;
      const setSourceList = isMine ? setMineTabList : setMoreTabList;
      const target = updateAppList(sourceList, setSourceList, item);
      if (target) {
        const idx = updateDeleteRef.current.findIndex((i) => i.sessionId === target.sessionId);
        if (idx > -1) {
          updateDeleteRef.current.splice(idx, 1);
        }
        setAppList([...appList, target]);
      }
    }
  };

  const handleShieldChange = (value: 0 | 1, type: string, index: number, isMine?: boolean) => {
    const getSourceList = () => {
      if (type === "tab") {
        return isMine ? mineTabList : moreTabList;
      }
      return appList;
    };

    const setSourceList = (newList: any[]) => {
      if (type === "tab") {
        isMine ? setMineTabList(newList) : setMoreTabList(newList);
      } else {
        setAppList(newList);
      }
    };

    const sourceList = getSourceList();
    const target = sourceList[index];
    target.settings.shield = value;
    setSourceList([...sourceList]);

    const updateTarget = updateSettingsListRef.current.find((item) => item.id === target.id);
    if (updateTarget) {
      updateTarget.settings.shield = value;
    } else {
      updateSettingsListRef.current.push(target);
    }
  };

  const updateShieldSettings = (list: Session[], value: 0 | 1) => {
    list.forEach((item) => {
      if (item.settings.shield !== value) {
        const updateTarget = updateSettingsListRef.current.find(
          (updateItem) => updateItem.id === item.id
        );
        if (updateTarget) {
          updateTarget.settings.shield = value;
        } else {
          updateSettingsListRef.current.push(item);
        }
        item.settings.shield = value;
      }
    });
  };

  const handleAllAISettingsChange = (value: 0 | 1) => {
    updateShieldSettings(mineTabList, value);
    updateShieldSettings(moreTabList, value);
    setMineTabList([...mineTabList]);
    setMoreTabList([...moreTabList]);
  };

  return (
    <Modal
      visible={visible}
      onOk={handleConfirm}
      onCancel={() => handleCancel()}
      centered
      okText="保存"
      cancelText="取消"
      title="应用通知管理"
      width="800px"
      className="controller-modal"
      bodyStyle={{ height: "402px" }}
      footer={activedKey === "session" ? null : undefined}
      confirmLoading={loading}
    >
      <Spin spinning={loading}>
        <div className="controller-modal-content">
          <div className="group-module">
            <div className="title">
              {aiConfigName}通知<span className="title-extra-text">（以下应用会聚合在{aiConfigName}通知）</span>
            </div>
            <div className="group-content">
              <DragDropContext
                onDragEnd={onDragEnd}
                onBeforeDragStart={() => {
                  analysisLog("Xtbg_Msg_AI", "Filter_Order");
                  setDragging(true);
                }}
              >
                <div>
                  <Droppable droppableId="mine">
                    {(provided, snapshot) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        <h3 className="label">展示页签</h3>
                        <div className="group-content-card">
                          <div className="all-section">
                            <div className="all-section-left">
                              <IconFont type="iconjs_ic_refuse" style={{ color: "#BFC1C4" }} />
                              <span className="text">全部</span>
                            </div>
                            <Dropdown
                              overlay={
                                <div className="ai-all-dropdown-content">
                                  <div
                                    className="ai-all-dropdown-action"
                                    onClick={() => handleAllAISettingsChange(0)}
                                  >
                                    <IconFont type="iconic_remind" style={{ color: "#62656D" }} />
                                    <span className="ai-all-dropdown-action-text">
                                      全部允许通知
                                    </span>
                                  </div>
                                  <div
                                    className="ai-all-dropdown-action"
                                    onClick={() => handleAllAISettingsChange(1)}
                                  >
                                    <IconFont
                                      type="iconic_cancelremind"
                                      style={{ color: "#62656D" }}
                                    />
                                    <span className="ai-all-dropdown-action-text">全部免打扰</span>
                                  </div>
                                </div>
                              }
                              placement="bottomCenter" /* trigger={['click']} */
                            >
                              <div className="all-section-right">批量设置</div>
                            </Dropdown>
                          </div>
                          <div className="item">
                            {mineTabList.map((item: Session, index: number) => (
                              <Draggable
                                key={item.id}
                                isDragDisabled={UNABLE_EDIT_TABS_PIN.includes(
                                  (item.info as Employee).userId
                                )}
                                draggableId={item.id}
                                index={index}
                              >
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={getItemStyle(
                                      snapshot.isDragging,
                                      provided.draggableProps.style,
                                      isPointer
                                      // item.recommended
                                    )}
                                    className="circular"
                                  >
                                    <DragableToolsItem
                                      onShieldChange={(value: 0 | 1) =>
                                        handleShieldChange(value, "tab", index, true)
                                      }
                                      setLoading={setLoading}
                                      isDragAble={
                                        !UNABLE_EDIT_TABS_PIN.includes(
                                          (item.info as Employee).userId
                                        )
                                      }
                                      length={mineTabList.length}
                                      key={item.id}
                                      toolsItem={item}
                                      isMine={true}
                                      provided={provided}
                                      droppableId="mine"
                                      handleToolsItemClick={handleToolsItemClick}
                                      index={index}
                                      isDragging={snapshot.isDragging}
                                      handleOk={handleOk}
                                      selectedTabList={selectedTabList}
                                      onAppToggle={handleAppToggle}
                                    />
                                  </div>
                                )}
                              </Draggable>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </Droppable>
                  <Droppable droppableId="more">
                    {(provided, snapshot) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        <h3 className="label">隐藏页签</h3>
                        <div className="group-content-card">
                          <div className="item last">
                            {moreTabList.length ? (
                              moreTabList.map((item: any, index: number) => {
                                return (
                                  <Draggable key={item.id} draggableId={item.id} index={index}>
                                    {(provided, snapshot) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style,
                                          isPointer
                                          // item.recommended
                                        )}
                                        className="circular"
                                      >
                                        <DragableToolsItem
                                          onShieldChange={(value: 0 | 1) =>
                                            handleShieldChange(value, "tab", index, false)
                                          }
                                          setLoading={setLoading}
                                          isDragAble={true}
                                          toolsItem={item}
                                          isMine={false}
                                          length={moreTabList.length}
                                          provided={provided}
                                          droppableId="more"
                                          handleToolsItemClick={handleToolsItemClick}
                                          index={index}
                                          isDragging={snapshot.isDragging}
                                          handleOk={handleOk}
                                          selectedTabList={selectedTabList}
                                          onAppToggle={handleAppToggle}
                                        />
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              })
                            ) : isDragging ? (
                              <div className="placeholder-div" />
                            ) : null}
                          </div>
                        </div>
                        {/* 解决组件react-beautiful-dnd滚动底部出现抖动问题 */}
                        {isDragging && (
                          <div
                            style={{
                              width: "100%",
                              height: "50px"
                            }}
                          />
                        )}
                      </div>
                    )}
                  </Droppable>
                </div>
              </DragDropContext>
            </div>
          </div>
          <div className="group-module">
            <div className="title">
              会话通知
              <span className="title-extra-text">（以下应用会在消息列表中发送通知）</span>
            </div>
            {appList.length ? (
              <div className="group-content">
                <div className="group-content-card">
                  {appList.map((item, index) => (
                    <ToolsItem
                      key={item.sessionId}
                      toolsItem={item}
                      isCustomApp
                      selectedTabList={selectedTabList}
                      onAppToggle={handleAppToggle}
                      onShieldChange={(value: 0 | 1) => handleShieldChange(value, "app", index)}
                    />
                  ))}
                </div>
              </div>
            ) : (
              <div className="ai-empty-container">
                <Empty
                  image={noticeImg}
                  imageStyle={{
                    height: 100
                  }}
                  description="暂无数据"
                />
              </div>
            )}
          </div>
        </div>
      </Spin>
    </Modal>
  );
}

function mapStateToProps({ chat }: any) {
  const {
    selectedSession,
    aiNoticeSessionList,
    allSessionList,
    currentEmployee
  } = chat as ChatState;
  return {
    selectedSession,
    aiNoticeSessionList,
    currentEmployee,
    allSessionList
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateCustomAppList: (payload: any) => {
      dispatch({ type: "chat/updateCustomAppList", payload });
    },
    async updateFilterTabList(data: { filterTabList: any[] }) {
      await dispatch({ type: "chat/updateFilterTabList", payload: data });
    },
    updateAISessionDataList: (payload: any) => {
      dispatch({ type: "chat/updateAISessionDataList", payload });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TabControllerModal);
